import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import ReactMarkdown from "react-markdown"; // ✅ Pour les tableaux et graphiques
import { articles as localArticles } from "../data/articles";

function ArticleDetails() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      setLoading(true);
      // 1. Chercher dans Firebase (Articles IA)
      const q = query(collection(db, "articles"), where("slug", "==", slug));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        setArticle({ id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() });
      } else {
        // 2. Chercher dans le fichier local si pas trouvé sur Firebase
        const local = localArticles.find((a) => a.slug === slug);
        setArticle(local);
      }
      setLoading(false);
    };

    fetchArticle();
    window.scrollTo(0, 0);
  }, [slug]);

  if (loading) return <div style={styles.loader}>Chargement de l'analyse...</div>;
  if (!article) return <div style={styles.loader}>Article introuvable.</div>;

  return (
    <div style={styles.container}>
      <img src={article.image} alt={article.title} style={styles.mainImg} />
      
      <h1 style={styles.title}>{article.title}</h1>
      
      <div style={styles.meta}>
        <span>📅 {article.date || "Mars 2026"}</span>
        <span>✍️ Par {article.author || "Mamadou Ly"}</span>
      </div>

      {/* Rendu du contenu Long (IA ou Manuel) */}
      <div style={styles.content}>
        <ReactMarkdown>{article.content}</ReactMarkdown>
      </div>

      {/* Bloc de Review (si c'est un test IA) */}
      {article.review && (
        <div style={styles.reviewCard}>
          <h2 style={{ color: "#00ffcc" }}>Verdict GamePulse HQ</h2>
          <div style={styles.score}>{article.review.score}</div>
          <p><strong>Verdict :</strong> {article.review.verdict}</p>
          <div style={{ display: "flex", gap: "20px", marginTop: "15px" }}>
            <div style={{ color: "#00ffcc" }}>✔️ {article.review.pros?.join(", ")}</div>
            <div style={{ color: "#ec008c" }}>❌ {article.review.cons?.join(", ")}</div>
          </div>
        </div>
      )}

      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <Link to="/blog" style={styles.backBtn}>Retour au Blog</Link>
      </div>
    </div>
  );
}

const styles = {
  container: { padding: "120px 20px", maxWidth: "900px", margin: "0 auto", color: "#fff", background: "#0f0f1b" },
  mainImg: { width: "100%", height: "450px", objectFit: "cover", borderRadius: "20px", marginBottom: "30px", boxShadow: "0 10px 30px rgba(0,0,0,0.5)" },
  title: { fontSize: "2.5rem", color: "#00ffcc", marginBottom: "15px" },
  meta: { display: "flex", gap: "20px", color: "#888", marginBottom: "40px", borderBottom: "1px solid #333", paddingBottom: "20px" },
  content: { lineHeight: "1.8", fontSize: "1.1rem", color: "#ccc" },
  reviewCard: { background: "#1a1b26", padding: "30px", borderRadius: "20px", marginTop: "50px", border: "1px solid #00ffcc" },
  score: { fontSize: "3rem", fontWeight: "bold", color: "#ec008c", margin: "10px 0" },
  backBtn: { padding: "12px 25px", border: "2px solid #00ffcc", color: "#00ffcc", textDecoration: "none", borderRadius: "8px", fontWeight: "bold" },
  loader: { color: "#00ffcc", textAlign: "center", paddingTop: "200px", fontSize: "1.5rem" }
};

export default ArticleDetails;